// src/components/AdminSideNav/AdminSideNav.jsx
import React, { useState } from 'react'; // Ensure useState is imported
import { NavLink } from 'react-router-dom';
import styles from './AdminSideNav.module.css';
import HamburgerIcon from '../../assets/icons/HamburgerIcon'; // Ensure this path is correct

// className prop can still be accepted if AdminLayout ever needs to hide it completely for other reasons
const AdminSideNav = ({ className }) => {
    const [isNavCollapsed, setIsNavCollapsed] = useState(false); // State for internal collapse

    const toggleNavCollapse = () => {
        setIsNavCollapsed(!isNavCollapsed);
    };

    return (
        <aside
            className={`${styles.adminSidebar} ${className || ''} ${isNavCollapsed ? styles.adminSidebarCollapsed : ''}`}
        >
            <div className={styles.sidebarHeader}> {/* New wrapper for the button */}
                <button
                    onClick={toggleNavCollapse}
                    className={styles.navToggleButton} /* New class for styling this button */
                    aria-label={isNavCollapsed ? "Show navigation" : "Hide navigation"}
                    aria-expanded={!isNavCollapsed}
                >
                    <HamburgerIcon color="var(--text-dark-muted, #555555)" /> {/* Icon color can be themed */}
                </button>
            </div>

            {/* The <nav> element and its separators are only rendered if not collapsed */}
            {!isNavCollapsed && (
                <nav> {/* Separator ::before will be on this nav */}
                    <ul> {/* Separator ::after will be on this ul */}
                        <li>
                            <NavLink
                                to="/admin/dashboard"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                                end
                            >
                                Dashboard
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/admin/reservations"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Reservation Management
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/admin/documents"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Document Management
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/admin/users"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                User Management
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/admin/closures"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Facility Closures
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/admin/calendar-settings"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Calendar Settings
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            )}
        </aside>
    );
};

export default AdminSideNav;